<aside class="sidebar" ref="sidebarRef" :class="{'hidden': hiddenSidebar, 'show': sidebar.collapse }" :style="{ 'height': sideheight }">
    <div class="sidebar__header" :class="{'active': showHeader}">
        <div class="sidebar__header-logo">            
            <a @click="!inSession && !isTeaser ? router.push({ name: 'grid' }) : toggleModal('close')">                
                <img alt="logo" class="logo" :src="getStaticImages('sidebarlogo')" />
            </a>
        </div>
        <div class="sidebar__header-nickname">{{ userStore.account.username.substring(0,26) }}</div>
        <div class="sidebar__header-user">
            <span class="amount" v-if="isLoggedIn()">{{ userStore.account.credits ? $filters.niceCredits(userStore.account.credits) : 0 }}</span>            
            <router-link v-if="isLoggedIn() && !inSession && !isTeaser" class="buy" :to="{name: 'payment'}">{{ $t('sidebar.upgrade') }}</router-link>
            <a v-if="isLoggedIn() && (inSession || isTeaser)" class="buy" @click="openPaymentTab()">{{ $t('sidebar.upgrade') }}</a>
            <!--<a @click="toggleModal('login')" v-if="!isLoggedIn()" class="buy">{{ $t('header.user.login') }}</a>-->
        </div>
        <div class="sidebar__header-search">
            <input type="text" v-model="sidebar.search" placeholder="....">
            <i class="fa-solid fa-magnifying-glass"></i>
        </div>
    </div>
    <div class="sidebar__tabs" :class="{'withHeader': showHeader}">
        <ul>
            <li :class="{active: sidebar.activeTab === 'peek'}" @click="sidebar.switchTab('peek')">{{ $t('sidebar.peekers') }}</li>
            <li :class="{active: sidebar.activeTab === 'voyeur'}" @click="sidebar.switchTab('voyeur')">{{ $t('sidebar.teaser') }}</li>
            <li :class="{active: sidebar.activeTab === 'favorites'}" @click="sidebar.switchTab('favorites')">{{ $t('sidebar.favorites') }}</li>
        </ul>
        <div class="sidebar__tabs-tab" v-if="sidebar.activeTab !== 'none' && !isVoyeur">
            <div class="sidebar__tabs-nodata" v-if="currentSlice.items.length < 1 && currentSlice.status != 'fetching'">{{ $t('sidebar.nodata') }}</div>
            <div class="sidebar__tabs-loader" v-if="currentSlice.status === 'fetching'"><img alt="logo" class="logo" :src="getStaticImages('sidebarloader')" /></div>
            <div class="grid">              
                <div class="grid__container" v-if="currentSlice.status=='fetched'">
                    <tile v-for="id of currentSlice.items" :key="id" :id="id" :type="'tile--sidebar'" :link="linkTiles" :current="currentPerformer" :colums="'grid__tile col-xs-1'" />
                </div>
            </div>
        </div>
        <div class="sidebar__tabs-tab" v-show="isVoyeur && Object.keys(current).length != 0">
            <div class="tease__sideContainer">
                <div class="tease__sideTile" v-for="[id, teaser] of Object.entries(current)" :key="id" :class="`tease__sideTile-pos-${teaser.position}`">
                    <tileTeaser :key="id" :position="teaser.position" :type="teaser.type" :location="'sidebar'" :performer="parseInt(id)" v-if="teaser.type === 'VOYEURPEEK'"></tileTeaser>
                </div>
            </div>
        </div>
    </div>
    <div class="sidebar__collapse" v-show="hiddenSidebar" @click="sidebar.switchState()"><i class="fa-solid" :class="[ sidebar.collapse ? 'fa-caret-left' : 'fa-caret-right']"></i></div>
</aside>
